import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTemplate } from '../../../../state';
import { useGetTicketCategoriesQuery } from '../../../../../../services/DimensionService/dimensionApi';

interface CategoryEditProps {
  isEditMode?: boolean;
}

const CategoryEdit: React.FC<CategoryEditProps> = ({ isEditMode = false }) => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);
  const { data: categories, isLoading, error } = useGetTicketCategoriesQuery();

  // Filter out CPSI, HST, and FAC — Facility Maintenance is for one-off tickets only
  const filteredCategories = categories?.filter(
    category => category.value !== 'CPSI' && category.value !== 'HST' && category.value !== 'FAC'
  ) || [];

  const handleChange = (event: any) => {
    dispatch(updateTemplate({ category: event.target.value }));
  };

  return (
    <FormControl size="small" sx={{ minWidth: 200 }} required>
      <InputLabel>Category *</InputLabel>
      <Select
        value={currentRecurringTask?.category || ''}
        onChange={handleChange}
        label="Category *"
        disabled={isEditMode || isLoading || !!error}
      >
        {isLoading ? (
          <MenuItem disabled>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Loading categories...
          </MenuItem>
        ) : error ? (
          <MenuItem disabled>Error loading categories</MenuItem>
        ) : (
          filteredCategories.map((category) => (
            <MenuItem key={category.value} value={category.value}>
              {category.name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default CategoryEdit;
